<div #gridHost class="accumulator-grid-host" *ngIf="viewAccumulators"
    [ngStyle]="{ 'max-height': gridMaxHeight, 'width': '100%' }">
    <kendo-grid scrollable="none" [data]="viewAccumulators.gridData" [sortable]="true"
        [sort]="viewAccumulators.state.sort"
        [groupable]="groupableServices ? { enabled: true, showFooter: false } : false" [resizable]="true"
        [group]="viewAccumulators.state.group" [rowClass]="accumulatorRowCallback" [ngStyle]="{ 'width': '100%' }"
        (dataStateChange)="accumulatorDataStateChange($event)">
        <kendo-grid-messages noRecords="{{ 'NO-ACCUMULATORS' | translate }}">
        </kendo-grid-messages>
        @if (groupableServices)
        {
        <kendo-grid-column #serviceNameCol field="serviceName" [width]="nameColumnWidthPx"
            title="{{ 'SERVICE-NAME' | translate }}" [hidden]="groupedByServiceName" [groupable]="true"
            [headerClass]="'accumulator-header-center accumulator-service-name-col'"
            [class]="{ accumulatorServiceNameColumn: true }">
        </kendo-grid-column>
        }
        <kendo-grid-column #accumulatorNameCol field="accumulatorName" [width]="nameColumnWidthPx"
            title="{{ 'ACCUMULATOR' | translate }}" [groupable]="false" [headerClass]="'accumulator-header-center'">
        </kendo-grid-column>
        <kendo-grid-column #frequencyCol field="frequencyName" [width]="uniformDataColumnWidthPx"
            title="{{ 'FREQUENCY' | translate }}" [groupable]="false" [headerClass]="'accumulator-header-center'">
        </kendo-grid-column>
        <kendo-grid-column #durationCol field="duration" [width]="uniformDataColumnWidthPx"
            title="{{ 'DURATION' | translate }}" [hidden]="!durationLoaded"
            [class]="{ accumulatorDurationColumn: true }" [groupable]="false"
            [headerClass]="'accumulator-header-center'">
            <ng-template *ngIf="groupableServices" kendoGridGroupFooterTemplate let-group="group">
                @if (hasFirstRowDuration(group))
                {
                <span class="accumulator-footer-remaining">
                    <span>{{ 'REMAINING-TOTAL' | translate }}:</span>
                    <span>{{ groupRemaining(group, durationGroupCount(group)) }} {{
                        getFirstRowFrequencyText(group) }}</span>
                </span>
                }
                @else
                {
                <span class="accumulator-group-footer-skip" aria-hidden="true"></span>
                }
            </ng-template>
            <ng-template kendoGridCellTemplate let-dataItem>
                <span *ngIf="dataItem.duration !== null">{{dataItem.duration}}</span>
                <span *ngIf="dataItem.duration === null">-</span>
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column-group title="{{'MAXIMUM' | translate}}" [headerClass]="'accumulator-group-header-center'">
            <kendo-grid-column #maxUnitsCol field="maxUnits" [width]="uniformDataColumnWidthPx"
                title="{{ 'UNITS' | translate }}" class="text-right" [groupable]="false"
                [headerClass]="'accumulator-header-center'">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <span *ngIf="dataItem.maxUnits !== null">{{dataItem.maxUnits}}</span>
                    <span *ngIf="dataItem.maxUnits === null">-</span>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column #maxAmountCol field="maxAmount" [width]="uniformDataColumnWidthPx"
                title="{{ 'AMOUNT' | translate }}" format="n2" class="text-right" [groupable]="false"
                [headerClass]="'accumulator-header-center'">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <span *ngIf="dataItem.maxAmount !== null">{{dataItem.maxAmount | number :
                        '1.2-2'}}</span>
                    <span *ngIf="dataItem.maxAmount === null">-</span>
                </ng-template>
            </kendo-grid-column>
        </kendo-grid-column-group>
        <kendo-grid-column-group title="{{newTitleKey | translate}}" [headerClass]="'accumulator-group-header-center'">
            <kendo-grid-column #totalUnitsCol field="totalUnits" [width]="uniformDataColumnWidthPx"
                title="{{ 'UNITS' | translate }}" [class]="{ accumulatorUnitColumn: true }" [groupable]="false"
                [headerClass]="'accumulator-header-center'">
            </kendo-grid-column>
            <kendo-grid-column #totalAmountCol field="totalAmount" [width]="uniformDataColumnWidthPx"
                title="{{ 'AMOUNT' | translate }}" [class]="{ accumulatorAmountColumn: true }" format="n2"
                [groupable]="false" [headerClass]="'accumulator-header-center'">
            </kendo-grid-column>
        </kendo-grid-column-group>
        <kendo-grid-column-group title="{{'REMAINING-TOTAL' | translate}}"
            [headerClass]="'accumulator-group-header-center'">
            <kendo-grid-column #remainingUnitsCol field="remainingUnits" [width]="uniformDataColumnWidthPx"
                title="{{ 'UNITS' | translate }}" [class]="{ remainingUnitColumn: true }" [groupable]="false"
                [headerClass]="'accumulator-header-center'">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <span *ngIf="dataItem.remainingUnits !== null">{{dataItem.remainingUnits}}</span>
                    <span *ngIf="dataItem.remainingUnits === null">-</span>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column #remainingAmountCol field="remainingAmount" [width]="uniformDataColumnWidthPx"
                title="{{ 'AMOUNT' | translate }}" [class]="{ remainingAmountColumn: true }" format="n2"
                [groupable]="false" [headerClass]="'accumulator-header-center'">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <span *ngIf="dataItem.remainingAmount !== null">{{dataItem.remainingAmount | number :
                        '1.2-2'}}</span>
                    <span *ngIf="dataItem.remainingAmount === null">-</span>
                </ng-template>
            </kendo-grid-column>
        </kendo-grid-column-group>
    </kendo-grid>
</div>